<template>
  <b-modal
    id="modal-accept-write-off-material"
    :title="$t('acceptance')"
    cancel-variant="outline-secondary"
    :ok-title="$t('general.save')"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    centered
    hide-footer
    size="lg"
    no-close-on-backdrop
  >
    <app-collapse>
      <template v-for="(item1, index1) in GET_APPLICATIONS_MATERIAL_ID.write_off">
        <app-collapse-item 
          :title="$t('write-off') + ' ' + (index1 + 1)"
          v-if="item1.is_new == true" 
          :key="index1"
        >
          <b-table
            class="table-bordered border"
            :fields="fields"
            :items="item1.objects"
            show-empty
            hover
            responsive
            :empty-text="$t('empty_text')"
          >
            <template #head()="props">
              <span>{{ $t(props.label) }}</span>
            </template>

            <template #cell(index)="{ index }">
              <span>{{ index + 1 }}</span>
            </template>

            <template #cell(brigade)="props">
              <span v-if="props && props.item && props.item.brigade && props.item.brigade.title">{{ props.item.brigade.title }}</span>
            </template>

            <template #cell(titlePermishin)="data">
              {{$_formatPriceMixin(data.item.quantity)}}
            </template>
          </b-table>

          <div class="d-flex justify-content-end">
            <div></div>
            <b-button
              variant="success"
              size="md"
              class="ml-50"
              @click="onSubmit(item1)"
              >
              {{$t('accept')}}
            </b-button>
          </div>

        </app-collapse-item>
      </template>
    </app-collapse>
  </b-modal>
</template>

<script>
import {
  BButton,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BTable,
  BFormSpinbutton,
  BFormCheckbox
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import priceFormatMixin from '@/mixins/priceFormatMixin';

export default {
  components: {
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BRow,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BTable,
    BFormSpinbutton,
    BButton,
    BCard,
    BFormCheckbox,

    AppCollapse,
    AppCollapseItem,
  },
  mixins: [priceFormatMixin],
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      fields: [
        {
          label: '№',
          key: 'index',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'brigade',
          key: 'brigade',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'view',
          key: 'product',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'namee',
          key: 'good',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'write-off_request',
          key: 'titlePermishin',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '20%' },
        },
      ],
      // ===============  PRIMARY_DATA_SECTION END ===============




    }
  },
  computed: {
    ...mapGetters('application', ['GET_APPLICATIONS_MATERIAL_ID']),
  },
  methods: {
    ...mapActions('materials', ['UPDATE_WRITE_OFF_FOR_GOOD']),
    ...mapActions('application', ['FETCH_APPLICATIONS_MATERIAL_ID']),





    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmit(value) {
      let goods = []
      value.objects.forEach(elem => {
        goods.push({good_id: elem.good_id, count: elem.quantity})
      })
      await this.UPDATE_WRITE_OFF_FOR_GOOD({id: value.id, data: {status_unique: 'accepted_write_off', goods: goods}})  
      await this.FETCH_APPLICATIONS_MATERIAL_ID({id: this.$route.params.id, params: {show_archive: 1}}) 
      this.$bvModal.hide('modal-accept-write-off-material')
      this.$emit('refreshCall', true)
    },
    // ===============  ON_SUBMIT_SECTION END ===============





  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.material .vs--disabled .vs__dropdown-toggle, [dir] .vs--disabled .vs__clear, [dir] .vs--disabled .vs__search, [dir] .vs--disabled .vs__selected, [dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: transparent !important;
}
</style>
